import React from 'react'
import Logo from '../Img/logo.png'
import API from '../Utils/api'
import {handleLogout} from '../Utils/auth'
import {Link} from 'react-router-dom'
import MasterTemplate from "./MasterTemplate";


const getUsuarioLocal = () => {
    const usuarioStorage = window.localStorage.getItem('user')
    const usuario = JSON.parse(usuarioStorage)

    return usuario
}

export class GerenciarGerentes extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        window.localStorage.setItem("returnRoute", window.location.href);
        super(props)
        this.state = {
            user: window.localStorage.getItem('user'),
            gerentes: [],
            filteredList: []
        }
    }

    componentDidMount() {
        try {
            this.listarGerentes()
        } catch (e) {
            console.error(`Error: ${e}`)
        }
    }

    handleResetSenha = async (id) => {
        try {
            const response = await API.get(`/api/usuarios/${id}/nova-senha`)
            const {data} = response

            if (data.error) throw new Error(data.error)

            const {novaSenha, email} = data
            alert(`Anote a nova senha: ${novaSenha}, email: ${email}`)
        } catch (e) {
            console.error(e.message)
        }
    }

    async handleChangeStatus(_usuario) {
        try {
            var res = await API.post('/api/usuarios/update-one-user', {_id: _usuario._id, status: !_usuario.status})
            if(res){
                window.location.reload();
            }
        } catch (err) {
            console.log(err)
        }
    }

    getUser = e => {
        try {
            const user = getUsuarioLocal()
            this.setState({user})
        } catch (err) {
            console.log(err)
        }
    }

    listarGerentes = async e => {
        const usuario = getUsuarioLocal()
        try {
            const response = await API.post('/api/usuarios/listar-todos-gerentes')

            this.setState({...this.state, gerentes: response.data.sort(this.compararNome)})
            this.setState({filteredList: this.state.gerentes});
        } catch (err) {
            console.log(err)
        }
    }

    compararNome (a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
          return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
          return -1;
        }

        return 0
      }

      searchEmail(e){
        var filteredList  = this.state.gerentes.filter(usuario => 
          {
            if(usuario != undefined && usuario.email.toLowerCase().includes(e.target.value.toLowerCase())){
            return usuario;
          }
        }
        )
        
        this.setState({filteredList : filteredList})
    }

    render() {
        return (
            <MasterTemplate label="Gerentes">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <Link
                                        to="/cadastro-gerente"
                                        className="btn btn-fill btn-success float-md-right float-lg-right"
                                    >
                                        Cadastrar
                                    </Link>
                                    <h4 className="card-title">Acompanhe seus gerentes</h4>
                                    <p className="card-category">Informações dos gerentes</p>
                                    <span className="text-dark font-weight-bold">Total de gerentes:</span> <span className="text-danger font-weight-bold"> {this.state.gerentes.length}</span>
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <div className="row pl-5 pr-5 justify-content-center">
                                        <input className="form-control w-50" placeholder="busca rapida por email..." onChange={this.searchEmail.bind(this)}></input>
                                    </div>

                                    <table className="table table-hover table-striped table-sm">
                                        <thead>
                                        <tr>
                                            <th scope="col">Nome</th>
                                            <th scope="col">Telefone</th>
                                            <th scope="col">Email</th>
                                            <th scope="col">Status</th>
                                            <th scope="col" className="w-100"></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.filteredList && this.state.filteredList.map((item, index) => {
                                            return (
                                                <tr scope="row" key={index}>
                                                    <td>
                                                        {item.nome}
                                                    </td>
                                                    <td>
                                                        {item.telefone}
                                                    </td>
                                                    <td>
                                                        {item.email}
                                                    </td>
                                                    <td>
                                                        {item.status ? 'Ativo' : 'Bloqueado'}
                                                    </td>
                                                    <td className="w-100 d-flex justify-content-center">
                                                        <div className="dropdown">
                                                            <Link to="#" id={`dLabel_${index}`}
                                                               type="button" data-toggle="dropdown"
                                                               aria-haspopup="true"
                                                               aria-expanded="false">
                                                                <i className="fas fa-ellipsis-h"></i>
                                                            </Link>
                                                            <div className="dropdown-menu"
                                                                 aria-labelledby={`dLabel_${index}`}>
                                                                <Link className="dropdown-item"
                                                                      to={`/cadastro-gerente?id=${item._id}`}>Editar</Link>
                                                                <Link to="#" className="dropdown-item"
                                                                   onClick={() => this.handleResetSenha(item._id)}>Redefinir
                                                                    senha</Link>
                                                                <button  className="dropdown-item"
                                                                   onClick={() => this.handleChangeStatus(item)}>{item.status ? 'Bloquear' : 'Ativar'}</button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MasterTemplate>
        )
    }
}

export default GerenciarGerentes
